// export const mqttConfig = {
//     'data': {
//         url: "wss://www.energydt.cn:18888/mqtt",
//         username: "vrmaker",
//         password: "vrmaker",
//     },
//     'control': {
//         url: "wss://www.energydt.cn/mq/ws",
//         username: "mqtt_ctrl",
//         password: "vrmaker",
//     }
// }

export const mqttConfig = {
    'data': {
        url: "ws://10.10.1.198:8083/mqtt",
        username: "vrmaker",
        password: "vrmaker",
    },
    'control': {
        url: "ws://10.10.1.198:8083/mq/ws",
        username: "mqtt_ctrl",
        password: "vrmaker",
    }
}